<template>
  <b-card title="" v-if="dataTKD.length > 0">
    <div>
      <h5 class="mb-1">Jadwal TKD</h5>
      <b-table :items="dataTKD" :fields="fieldsTKD"></b-table>
    </div>
    <br>
    <div>
      <h5 class="mb-1">Jadwal Wawancara</h5>
      <b-table :items="dataWawancara
      " :fields="fields"></b-table>
    </div>
</b-card>
</template>


<script>
import { BTable, BCard } from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import {
  getJadwal,
} from '@/connection-api/lembarkehidupan'

export default {
  components: {
    BCardCode,
    AppTimeline,
    AppTimelineItem,
    BTable,
    BCard,
  },
  data() {
    return {
      dataTKD: [],
      dataWawancara: [],
      items: [],
      fields: [
        { key: 'tanggal', label: 'Tanggal' },
        { key: 'waktu_wawancara', label: 'Jam' },
        { key: 'tempat_wawancara', label: 'Lokasi' }
      ],
      fieldsTKD: [
        { key: 'tanggal', label: 'Tanggal' },
        { key: 'waktu_tkd', label: 'Jam' },
        { key: 'durasi', label: 'Durasi' },
        { key: 'tempat_test', label: 'Lokasi' }
      ]
    }
  },
  async mounted() {
    // Fetch the JSON data and assign it to timelineData
    try {
      const response = await getJadwal();
      this.dataTKD = response.data.data.tkd;
      this.dataWawancara = response.data.data.wawancara;
    } catch (error) {
      console.error(error);
    }
  },
}
</script>
